export default __webpack_public_path__ + "locales/el-GR/SingleSignOn.json?hash=74662e7a978b89aea67eed2b59a77874";